import * as I from 'immutable';
import React from 'react';

import {useOverlays} from 'app/components/Library/OverlaysProvider';
import {usePushNotification} from 'app/components/Notification';
import api from 'app/modules/Remote/api';
import {HydratedFeatureCollection} from 'app/modules/Remote/FeatureCollection';
import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization';
import {LoggedInUserActions} from 'app/providers/AuthProvider';

import {useManageFeatures} from './ManageFeaturesProvider';
import ManageFeaturesView from './ManageFeaturesView';

export interface Props {
  overlayFeatureCollectionId: number;
  organization: I.ImmutableOf<ApiOrganization>;
  profile: I.ImmutableOf<ApiOrganizationUser>;
  loggedInUserActions: LoggedInUserActions;
  firebaseToken: string | null;
}

const ManageUpdateOverlay: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  overlayFeatureCollectionId,
  organization,
  profile,
  loggedInUserActions,
  firebaseToken,
}) => {
  const {manageFeaturesState, manageFeaturesActions, loading} = useManageFeatures();
  const {overlays} = useOverlays();
  const pushNotification = usePushNotification();

  const overlay = overlays.find(
    (o) => o?.get('featureCollectionId') === overlayFeatureCollectionId
  );
  const overlayName = overlay?.get('name') ?? '';

  const [existingOverlayFc, setExistingOverlayFc] =
    React.useState<HydratedFeatureCollection | null>(null);

  React.useEffect(() => {
    api.featureCollections
      .fetch(overlayFeatureCollectionId)
      .then((res) => {
        setExistingOverlayFc(res.get('data') as unknown as HydratedFeatureCollection);
      })
      .catch((e) => {
        console.error(e);
        pushNotification({
          message: 'Could not load the current overlay preview.',
          autoHideDuration: 4000,
        });
      });
  }, [overlayFeatureCollectionId, pushNotification]);

  return (
    <ManageFeaturesView
      profile={profile}
      organization={organization}
      loggedInUserActions={loggedInUserActions}
      manageFeaturesState={manageFeaturesState}
      manageFeaturesActions={manageFeaturesActions}
      mode={'updateOverlay'}
      loading={loading}
      overlayNames={[]}
      existingOverlayName={overlayName}
      existingOverlayFeatureCollection={existingOverlayFc}
      firebaseToken={firebaseToken}
    />
  );
};

export default ManageUpdateOverlay;
